import { useAuth } from 'oidc-react';
import { AccessLevel, Permission, PERMISSIONS, Role, isEditAccess } from '../common/Utils/permissions';

/**
 * Single source of truth for "can the current user create/modify/act, or only view".
 * Wraps the PERMISSIONS config so pages/components don't each re-derive role + perms.
 */
export const usePermissions = () => {
  const auth = useAuth();
  const role = (auth?.userData?.profile?.role as Role | undefined) ?? 'tenantadmin';
  const perms: Permission = PERMISSIONS[role] || {};

  const levelOf = (area: keyof Permission): AccessLevel | undefined => perms[area] as AccessLevel | undefined;

  // True when the area's access level allows creating/editing/acting (not just viewing).
  const canEdit = (area: keyof Permission): boolean => isEditAccess(levelOf(area));

  const isMenuHidden = (menuKey: string): boolean => !!perms.hiddenMenus?.includes(menuKey);

  return { role, perms, levelOf, canEdit, isMenuHidden };
};

export default usePermissions;
